<template>
  <v-container fluid>
    <!-- Toolbar Header -->
    <v-skeleton-loader :loading="loading" transition="scale-transition" max-height="64" type="table-heading">
      <v-toolbar color="primary" class="header-title text-white">
        <v-toolbar-title class="title">{{ $t('Tax Dashboard') }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="title text-end pr-4">{{ today }}</v-toolbar-title>
      </v-toolbar>
    </v-skeleton-loader>

    <!-- Tabs -->
    <v-tabs v-model="activeTab" class="mt-2" color="#76237E" slider-color="#76237E">
      <v-tab :value="0">
        <v-icon size="small" class="mr-2">mdi-chart-timeline-variant</v-icon>
        Live to Date
      </v-tab>
      <v-tab :value="1">
        <v-icon size="small" class="mr-2">mdi-calendar-text</v-icon>
        Year to Date
      </v-tab>
    </v-tabs>
    <v-divider />

    <v-window v-model="activeTab" class="">
      <v-window-item :value="0">
        <LiveToDateTab />
      </v-window-item>
      <v-window-item :value="1" class="">
        <YearToDateTab />
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import { ref, computed } from 'vue';
import LiveToDateTab from '@/components/TaxDashboard/LiveToDateTab.vue';
import YearToDateTab from '@/components/TaxDashboard/YearToDateTab.vue';

export default {
  name: 'TaxDashboard',
  components: {
    LiveToDateTab,
    YearToDateTab,
  },
  setup() {
    const loading = ref(false);
    const activeTab = ref(0);

    const today = computed(() => {
      return new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    });

    return {
      loading,
      activeTab,
      today,
    };
  },
};
</script>

<style scoped>
/* ApexCharts custom styling */
:deep(.apexcharts-tooltip) {
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

:deep(.apexcharts-datalabel-label) {
  font-weight: 600 !important;
  font-size: 12px !important;
}

:deep(.apexcharts-datalabel-value) {
  font-weight: 700 !important;
  font-size: 24px !important;
}
</style>
